module.exports = __webpack_public_path__ + "static/media/localRepDefault.db473a9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/localRepDefault.jpg
// module id = 89
// module chunks = 4